<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px padding-left-10px">



        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body padding-top-0px padding-bottom-0px">



        <ul class="nav nav-tabs nav-tab-service2 margin-top-13px" id="tabContent">
          <li class="active margin-right-15px"><a class="nav-itemerp active" href="#Vendor" data-toggle="tab" hidden>Add Vendor</a></li>
          <li class="margin-right-15px"><a class="nav-itemerp active" href="#Material" data-toggle="tab">Add Material To Goods Inward</a></li>

        </ul>

        <div class="tab-content">
          <div class="tab-pane active" id="Vendor" hidden>
            <div class="card">
              <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-0px">
                <div class="row border-top border-bottom bk-color-light margin-left-zero margin-right-0px">
                  <div class="col-md-4  text-align-center padding-right-0px padding-left-0px border-right-1px">
                    <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Material Name</h4></div>
                    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Checkin font-weight-bold" *ngIf="MaterialName">{{MaterialName}}</h4></div>
                  </div>
                  <div class="col-md-4  text-align-center padding-right-0px padding-left-0px border-right-1px">
                    <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Store Location</h4></div>
                    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Assign" *ngIf="StroreLocation">{{StroreLocation}}</h4></div>
                  </div>
                  <div class="col-md-4 text-align-center padding-right-0px padding-left-0px border-right-1px">
                    <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Consumption Group</h4></div>
                    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline" *ngIf="ConsumptionGroup">{{ConsumptionGroup}}</h4> </div>
                  </div>
                  <!--<div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
                    <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Required Qty</h4></div>
                    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-checkout"></h4></div>
                  </div>-->
                  <!--<div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
                    <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Item Name</h4></div>
                    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline"> Consultant</h4></div>
                  </div>
                  <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
                    <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Requst Qty</h4></div>
                    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline">2</h4></div>
                  </div>-->
                </div>
                <!--<div class="row">
                  <div class="col-md-12 padding-right-9px padding-left-10px">
                    <div class="row font-size-14 margin-top-10 margin-left-0px">
                      <div class="col-md-2">
                        <h4 class="margin-bottom-0px margin-top-3px">Selected Batch </h4>
                      </div>:
                      <div class="col-md-7  padding-left-10px my-profile-form">

                        <div class="form-group margin-bottom-0px">

                          <h4 class="margin-bottom-0px  margin-top-3px"></h4>


                        </div>


                      </div>

                    </div>
                  </div>

                </div>-->
                <div class="row">
                  <div class="col-md-12 padding-l-0px">
                    <form class="form" novalidate="" (ngSubmit)="General()" #f="ngForm">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general padding-top-0px">

                          <div class="row">
                            <div class="col-md-12">


                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px"> Name </label>
                                    </div>
                                    <div class="col-md-3">

                                      <input type="text" class="form-control" placeholder="Name"
                                             id="CurrentSaveVendorInfoRequest.VendorName"
                                             [(ngModel)]="CurrentSaveVendorInfoRequest.VendorName"
                                             name="CurrentSaveVendorInfoRequest.VendorName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" minlength="1" #VName="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!VName.valid && (VName.dirty || VName.touched) && VName.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!VName.valid && VName.errors.pattern)">(special characters are not allowed)</small>

                                    </div>

                                  </div>

                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Mobile Phone </label>
                                    </div>
                                    <div class="col-md-3">
                                      <input type="tel" class="form-control" placeholder="Mobile Phone"
                                             id="CurrentSaveVendorInfoRequest.ContactNo"
                                             [(ngModel)]="CurrentSaveVendorInfoRequest.ContactNo"
                                             mask="(000) 000-0000"
                                             name="CurrentSaveVendorInfoRequest.ContactNo" pattern="[0-9]{10}" #phone1="ngModel">
                                      <!--<small class="form-text text-danger"
                                      *ngIf="(!phone1.valid && (phone1.dirty || phone1.touched) && phone1.errors.required )">(Field cannot be left blank)</small>-->
                                      <small class="form-text text-danger"
                                             *ngIf="(!phone1.valid)">(Provide Valid CellNo)</small>
                                    </div>
                                  </div>


                                </div>
                              </div>



                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-3 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Location</label>
                                    </div>

                                    <div class="col-md-3">
                                      <input type="text" class="form-control" placeholder="Location"
                                             id="CurrentSaveVendorInfoRequest.Location"
                                             [(ngModel)]="CurrentSaveVendorInfoRequest.Location"
                                             name="CurrentSaveVendorInfoRequest.Location" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" #Location="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Location.valid && (Location.dirty || Location.touched) && Location.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Location.valid && Location.errors.pattern)">(special characters are not allowed)</small>

                                    </div>
                                  </div>


                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-3 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Address</label>
                                    </div>

                                    <div class="col-md-3">
                                      <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                                name="CurrentSaveVendorInfoRequest.AddressLine1"
                                                [(ngModel)]="CurrentSaveVendorInfoRequest.AddressLine1" minlength="1" maxlength="100"
                                                #addconcerns_text1="ngModel"></textarea>
                                      <small class="form-text text-danger"
                                             *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>
                                    </div>
                                  </div>


                                </div>
                              </div>

                            </div>


                          </div>
                        </div>
                        <div class="card-footer">
                          <!--<button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>-->
                          <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <!--<div class="card-footer text-align-center">
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
              </div>-->
            </div>


          </div>

          <div class="tab-pane active" id="Material">

            <form class="form" novalidate="" (ngSubmit)="Education()" #fm="ngForm">

              <div class="card ">

                <div class="card-body margin-left-zero padding-top-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-0px">
                          <div class="row border-top border-bottom bk-color-light margin-left-zero margin-right-0px">
                            <div class="col-md-4  text-align-center padding-right-0px padding-left-0px border-right-1px">
                              <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Material Name</h4></div>
                              <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Checkin font-weight-bold" *ngIf="MaterialName">{{MaterialName}}</h4></div>
                            </div>
                            <div class="col-md-4  text-align-center padding-right-0px padding-left-0px border-right-1px">
                              <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Store Location</h4></div>
                              <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Assign" *ngIf="StroreLocation">{{StroreLocation}}</h4></div>
                            </div>
                            <div class="col-md-4 text-align-center padding-right-0px padding-left-0px border-right-1px">
                              <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Purchase Order#</h4></div>
                              <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline">Kites-P017001771</h4> </div>
                            </div>

                            <!--<div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
                              <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Required Qty</h4></div>
                              <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-checkout"></h4></div>
                            </div>-->
                            <!--<div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
                              <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Item Name</h4></div>
                              <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline"> Consultant</h4></div>
                            </div>
                            <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
                              <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Requst Qty</h4></div>
                              <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline">2</h4></div>
                            </div>-->
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="row" hidden>
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="firstName" class="margin-bottom-0px margin-top-3px">Material Name </label>
                                    </div>:
                                    <div class="col-md-5">

                                      <h4 class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold font-size-16px" *ngIf="MaterialName">{{MaterialName}}</h4>

                                    </div>

                                  </div>

                                </div>
                              </div>

                              <div class="row" hidden>
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px">Store</label>
                                    </div>:
                                    <div class="col-md-5">
                                      <h4 class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold font-size-16px" *ngIf="StroreLocation">{{StroreLocation}}</h4>
                                      <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                                     [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                                     name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
                                      </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Test"
                                             id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                             [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                             name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                             maxlength="100" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                      <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                               id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                               [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                               name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                                      </CustomDataByRequestType>-->
                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row margin-top-10">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-2px">Supplier</label>
                                    </div>:
                                    <div class="col-md-5">
                                      <h4 class="margin-bottom-0px color-Assign margin-top-5px font-weight-bold">Radha Pharmacy</h4>
                                      <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                                     [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                                     name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
                                      </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Test"
                                             id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                             [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                             name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                             maxlength="100" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                      <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                               id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                               [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                               name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                                      </CustomDataByRequestType>-->
                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Batch no</label>
                                    </div>

                                    <div class="col-md-5">
                                      <input type="text" class="form-control" placeholder="Batchno"
                                             id="CurrentSaveMaterialToStoreInfoRequest.BatchNo"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.BatchNo"
                                             name="CurrentSaveMaterialToStoreInfoRequest.BatchNo" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" required #Batchno="ngModel">
                                      <small class="form-text text-danger"
                                             *ngIf="(!Batchno.valid && (Batchno.dirty || Batchno.touched) && Batchno.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Batchno.valid && Batchno.errors.pattern)">(special characters are not allowed)</small>

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Batch Quantity</label>
                                    </div>

                                    <div class="col-md-5">
                                      <input type="text" class="form-control" placeholder="Batch Qunatity"
                                             id="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             name="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             maxlength="30" #Qunatity="ngModel"
                                             pattern="^[\0-9,._\-?]*$" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Qunatity.valid && (Qunatity.dirty || Qunatity.touched) && Qunatity.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Qunatity.valid && Qunatity.errors.pattern)">(only numbers are allowed)</small>


                                    </div>
                                  </div>


                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Mfg Date</label>
                                    </div>

                                    <div class="col-md-5">

                                      <div class="date-form">
                                        <input type="text" class="form-control form-control-patient" placeholder="Date Of Birth"
                                               name="dp" [(ngModel)]="MfgDate" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" required #d="ngbDatepicker" #DOBin="ngModel">
                                        <small class="form-text text-danger"
                                               *ngIf="(!DOBin.valid && (DOBin.dirty || DOBin.touched) && DOBin.errors.required)">(Field cannot be left blank)</small>

                                        <a (click)="d.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>

                                    </div>
                                  </div>


                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Exp Date</label>
                                    </div>

                                    <div class="col-md-5">
                                      <div class="date-form">
                                        <input class="form-control form-control-patient" placeholder="Date Of Birth"
                                               name="dps" [(ngModel)]="ExpDate" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" required #d1fe="ngbDatepicker" #DOBfe="ngModel">
                                        <small class="form-text text-danger"
                                               *ngIf="(!DOBfe.valid && (DOBfe.dirty || DOBfe.touched) && DOBfe.errors.required)">(Field cannot be left blank)</small>

                                        <a (click)="d1fe.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>


                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Purchase Price</label>
                                    </div>

                                    <div class="col-md-5">
                                      <input type="text" class="form-control" placeholder="Purchase Price"
                                             id="CurrentSaveMaterialToStoreInfoRequest.PurchasingPrice"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.PurchasingPrice"
                                             name="CurrentSaveMaterialToStoreInfoRequest.PurchasingPrice"
                                             maxlength="30" #Pp="ngModel"
                                             pattern="^[\0-9,._\-?]*$" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Pp.valid && (Pp.dirty || Pp.touched) && Pp.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Pp.valid && Pp.errors.pattern)">(only numbers are allowed)</small>

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Selling Price</label>
                                    </div>

                                    <div class="col-md-5">
                                      <input type="text" class="form-control" placeholder="Selling Price"
                                             id="CurrentSaveMaterialToStoreInfoRequest.SellingPrice"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.SellingPrice"
                                             name="CurrentSaveMaterialToStoreInfoRequest.SellingPrice"
                                             maxlength="30" #Sp="ngModel"
                                             pattern="^[\0-9,._\-?]*$" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Sp.valid && (Sp.dirty || Sp.touched) && Sp.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Sp.valid && Sp.errors.pattern)">(only numbers are allowed)</small>

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px">GST</label>
                                    </div>
                                    <div class="col-md-5">

                                      <CodeTypeValue CodeType="TAXPC" id="CurrentSaveMaterialToStoreInfoRequest.GST"
                                                     [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.GST" SelectedValue=""
                                                     name="CurrentSaveMaterialToStoreInfoRequest.GST" required>
                                      </CodeTypeValue>
                                      <!--<input type="text" class="form-control" placeholder="Test"
                                             id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                             [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                             name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                             maxlength="100" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                      <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                               id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                               [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                               name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                                      </CustomDataByRequestType>-->
                                    </div>

                                  </div>

                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="row" hidden>
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px">Tax Type</label>
                                    </div>
                                    <div class="col-md-5">
                                      <CustomDataByRequestType RequestedType="AccessibleStores" FacilityCode={{FacilityCode}} class="form-group" SelectedValue="StoreCode"
                                                               [(ngModel)]="StoreCode"
                                                               name="StoreCodename" #sign2="ngModel">
                                      </CustomDataByRequestType>
                                      <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                                     [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                                     name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
                                      </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Test"
                                             id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                             [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                             name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                             maxlength="100" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                      <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                               id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                               [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                               name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                                      </CustomDataByRequestType>-->
                                    </div>

                                  </div>

                                </div>
                              </div>

                              <div class="row" hidden>
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px">Tax%</label>
                                    </div>
                                    <div class="col-md-5">
                                      <CustomDataByRequestType RequestedType="AccessibleStores" FacilityCode={{FacilityCode}} class="form-group" SelectedValue="StoreCode"
                                                               [(ngModel)]="StoreCode"
                                                               name="StoreCodename" #sign2="ngModel">
                                      </CustomDataByRequestType>
                                      <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                                     [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                                     name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
                                      </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Test"
                                             id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                             [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                             name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                             maxlength="100" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                      <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                               id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                               [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                               name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                                      </CustomDataByRequestType>-->
                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px">
                                        Order Qty
                                      </label>
                                    </div>
                                    <div class="col-md-5">
                                      <input type="text" class="form-control" placeholder="Order Qty"
                                             id="CurrentSaveMaterialToStoreInfoRequest.BatchNo"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.BatchNo"
                                             name="CurrentSaveMaterialToStoreInfoRequest.BatchNo" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" required #Batchno="ngModel">
                                      <small class="form-text text-danger"
                                             *ngIf="(!Batchno.valid && (Batchno.dirty || Batchno.touched) && Batchno.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Batchno.valid && Batchno.errors.pattern)">(special characters are not allowed)</small>
                                      <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                                     [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                                     name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
                                      </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Test"
                                             id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                             [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                             name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                             maxlength="100" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                      <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                               id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                               [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                               name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                                      </CustomDataByRequestType>-->
                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Bonus Qty</label>
                                    </div>

                                    <div class="col-md-5">
                                      <input type="text" class="form-control" placeholder="Bonus Qty"
                                             id="CurrentSaveMaterialToStoreInfoRequest.BatchNo"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.BatchNo"
                                             name="CurrentSaveMaterialToStoreInfoRequest.BatchNo" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" required #Batchno="ngModel">
                                      <small class="form-text text-danger"
                                             *ngIf="(!Batchno.valid && (Batchno.dirty || Batchno.touched) && Batchno.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Batchno.valid && Batchno.errors.pattern)">(special characters are not allowed)</small>

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Packing</label>
                                    </div>

                                    <div class="col-md-5">
                                      <input type="text" class="form-control" placeholder="Packing"
                                             id="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             name="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             maxlength="30" #Qunatity="ngModel"
                                             pattern="^[\0-9,._\-?]*$" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Qunatity.valid && (Qunatity.dirty || Qunatity.touched) && Qunatity.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Qunatity.valid && Qunatity.errors.pattern)">(only numbers are allowed)</small>


                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Units Per Pack</label>
                                    </div>

                                    <div class="col-md-5">
                                      <input type="text" class="form-control" placeholder="Units Per Pack"
                                             id="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             name="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             maxlength="30" #Qunatity="ngModel"
                                             pattern="^[\0-9,._\-?]*$" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Qunatity.valid && (Qunatity.dirty || Qunatity.touched) && Qunatity.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Qunatity.valid && Qunatity.errors.pattern)">(only numbers are allowed)</small>


                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Item Tax</label>
                                    </div>

                                    <div class="col-md-5">

                                      <input type="text" class="form-control" placeholder="Item Tax"
                                             id="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             name="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             maxlength="30" #Qunatity="ngModel"
                                             pattern="^[\0-9,._\-?]*$" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Qunatity.valid && (Qunatity.dirty || Qunatity.touched) && Qunatity.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Qunatity.valid && Qunatity.errors.pattern)">(only numbers are allowed)</small>

                                    </div>
                                  </div>


                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">MRP</label>
                                    </div>

                                    <div class="col-md-5">
                                      <input type="text" class="form-control" placeholder="MRP"
                                             id="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             name="CurrentSaveMaterialToStoreInfoRequest.StockInUnits"
                                             maxlength="30" #Qunatity="ngModel"
                                             pattern="^[\0-9,._\-?]*$" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Qunatity.valid && (Qunatity.dirty || Qunatity.touched) && Qunatity.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Qunatity.valid && Qunatity.errors.pattern)">(only numbers are allowed)</small>

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row" hidden>
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Item Discount</label>
                                    </div>

                                    <div class="col-md-5">
                                      <input type="text" class="form-control" placeholder="Item Discount"
                                             id="CurrentSaveMaterialToStoreInfoRequest.PurchasingPrice"
                                             [(ngModel)]="CurrentSaveMaterialToStoreInfoRequest.PurchasingPrice"
                                             name="CurrentSaveMaterialToStoreInfoRequest.PurchasingPrice"
                                             maxlength="30" #Pp="ngModel"
                                             pattern="^[\0-9,._\-?]*$" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Pp.valid && (Pp.dirty || Pp.touched) && Pp.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Pp.valid && Pp.errors.pattern)">(only numbers are allowed)</small>

                                    </div>
                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <!--<button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>-->
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px" [disabled]="!fm.form.valid" *ngIf='isvisiblem'>Save</button>
                </div>
              </div>

            </form>





          </div>




        </div>











      </div>



    </div>

  </div>
</div>


